import { Component, Input, EventEmitter, Output } from '@angular/core';
import { ProductTimeSpan } from '../../models/product-time-span';

@Component({
  selector: 'app-product-time-span',
  templateUrl: 'product-time-span.component.html',
  styleUrls: ['product-time-span.component.scss']
})
export class ProductTimeSpanComponent {
  @Input() productTimeSpan: ProductTimeSpan;
}
